import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {


  private resourcesIDs = new BehaviorSubject<any>({});
  resourcesIDsIndex$ = this.resourcesIDs.asObservable();

  setResourcesIDs(data: any) {
    this.resourcesIDs.next(data);
  }
}
